import { h, Component } from 'preact';

import FontAwesomeIcon from './fontAwesomeIcon.js';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import ContentHandler from '../util/contentHandler.js';
import style from '../../style/contractor.sass';

const getContractorPhoneNumberStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      contractorPhoneNumberContainer: style.contractorPhoneNumberContainer,
      contractorPhoneNumber: style.contractorPhoneNumber
    };
  }
  if(brand === 'ruud'){
    return {
      contractorPhoneNumberContainer: style.contractorPhoneNumberContainerRuud,
      contractorPhoneNumber: style.contractorPhoneNumberRuud
    };
  }
  if(brand === 'friedrich'){
    return {
      contractorPhoneNumberContainer: style.contractorPhoneNumberContainerFriedrich,
      contractorPhoneNumber: style.contractorPhoneNumberFriedrich
    };
  }
  return {
    contractorPhoneNumberContainer: style.contractorPhoneNumberContainer,
    contractorPhoneNumber: style.contractorPhoneNumber
  };
};


export default class ContractorPhoneNumber extends Component {
//<i className={style.contractorIcon}><FontAwesomeIcon icon={faPhone} size="32px" /></i>
  render(props, state) {
    const contractorId = props.contractor?props.contractor.id:null;
    const contentHandler = new ContentHandler();
    const trackingNumber = contentHandler.getTrackingPhoneNumber(props, contractorId);
    if(!trackingNumber){
      return null;
    }
    const classNames = getContractorPhoneNumberStyleClassNames(props.brand);
    return (
      <div className={classNames.contractorPhoneNumberContainer}>
        <a style={{...props.style}} className={classNames.contractorPhoneNumber} onClick={props.sendClickToCallData} href={'tel:'+trackingNumber}>
          {contentHandler.formatPhoneNumber(trackingNumber)}
        </a>
      </div>
    );
  }
}
